import html2canvas from "html2canvas"
import iconGresults from "../../../../design/assests/images/pdf_icons/good-results.png"
import { numberFormatter } from "../../../../utils/numbers.utils"
import { formatDateRange } from "../../../../utils/date.utils"

export const buildBurnchartSection = async (
  doc,
  y,
  refsToCapture,
  burnchartSummary,
  clientName,
  clientLogo,
  sprintData,
  buildHeaderSection,
  extraData
) => {
  const milestone = extraData?.milestone || null

  const milestoneTotalPoints = Number(milestone?.totalPoints)
  const hasMilestoneTotalPoints = Number.isFinite(milestoneTotalPoints)

  const hasReleaseName = Boolean(milestone?.nextImportantDateName?.trim())
  const hasReleaseDate = Boolean(milestone?.nextImportantDate)
  const hasReleaseInfo = hasReleaseName && hasReleaseDate

  const releaseName = hasReleaseName ? milestone.nextImportantDateName : null
  const releaseDate =
    hasReleaseDate ?
      formatDateRange(milestone.nextImportantDate, milestone.nextImportantDate)
    : null

  const pageWidth = doc.internal.pageSize.getWidth()
  const pageHeight = doc.internal.pageSize.getHeight()

  const sideMargin = 10
  const bottomMargin = 25
  const topMargin = 20

  const usableWidth = pageWidth - sideMargin * 2
  const columnWidth = usableWidth / 4

  const titleColor = "#24292F"
  const labelColor = "#737E8D"
  const valueColor = "#24292F"

  const iconSize = 6
  const spacing = 2
  const iconOffsetY = 4.5

  const burnchartDiv = refsToCapture.BURNCHART

  if (!burnchartDiv) return y + 10

  const formatValue = (value) => (value == null ? "-" : value.toLocaleString())

  // page break preventivo
  if (y > pageHeight - 95) {
    doc.addPage()
    y = await buildHeaderSection(
      doc,
      sprintData,
      topMargin,
      clientName,
      clientLogo
    )
  }

  doc.addImage(
    iconGresults,
    "PNG",
    sideMargin,
    y - iconOffsetY,
    iconSize,
    iconSize
  )

  doc.setFont("Cairo-SemiBold", "normal")
  doc.setFontSize(9)
  doc.setTextColor(titleColor)

  doc.text("Burnchart", sideMargin + iconSize + spacing, y)

  y += 8

  const contentTopY = y

  try {
    const clone = burnchartDiv.cloneNode(true)

    function forceLightMode(node) {
      if (!node || !node.style) return

      const tag = node.tagName?.toLowerCase()

      if (tag !== "text" && tag !== "tspan") {
        node.style.background = "#ffffff"
        node.style.backgroundColor = "#ffffff"
      }

      if (tag === "text" || tag === "tspan") {
        const currentFill = node.getAttribute("fill")

        if (
          currentFill &&
          (currentFill.toUpperCase() === "#FFFFFF" ||
            currentFill.toUpperCase() === "#FFF" ||
            currentFill.toLowerCase() === "white")
        ) {
          node.style.fill = "#FFFFFF"
          node.setAttribute("fill", "#FFFFFF")
        } else {
          node.style.fill = "#24292F"
          node.setAttribute("fill", "#24292F")
        }
      } else if (tag === "span" || tag === "strong" || tag === "p") {
        node.style.color = "#24292F"
      }

      if (node.children) {
        Array.from(node.children).forEach(forceLightMode)
      }
    }

    forceLightMode(clone)

    const noData =
      clone.textContent?.includes("Sin información") ||
      clone.textContent?.includes("No hay proyecciones disponibles")

    const svg = clone.querySelector("svg")
    if (svg) {
      const originalSvg = burnchartDiv.querySelector("svg")
      const rect = originalSvg?.getBoundingClientRect()

      if (rect) {
        const originalWidth = rect.width
        const originalHeight = rect.height
        const originalAspectRatio = originalHeight / originalWidth

        // Definir ANCHO objetivo (consistente para todas las resoluciones)
        const TARGET_WIDTH = 1000
        const targetHeight = TARGET_WIDTH * originalAspectRatio

        svg.setAttribute("width", TARGET_WIDTH)
        svg.setAttribute("height", targetHeight)
        svg.style.width = `${TARGET_WIDTH}px`
        svg.style.height = `${targetHeight}px`
      }
    }

    clone.style.position = "fixed"
    clone.style.left = "-9999px"
    clone.style.top = "0"

    document.body.appendChild(clone)

    const canvas = await html2canvas(clone, {
      scale: 3,
      useCORS: true,
      backgroundColor: "#ffffff",
    })

    document.body.removeChild(clone)

    const imgData = canvas.toDataURL("image/png")
    const graphWidth = columnWidth * 2.8 // Volver al valor original

    // Calcular altura proporcional
    const aspectRatio = canvas.height / canvas.width
    const imgHeight = graphWidth * aspectRatio

    // Usar altura mínima para que los números sean legibles

    const finalWidth = graphWidth
    const finalHeight = graphWidth * aspectRatio

    // Si la altura excede el máximo, escalar TODO proporcionalmente
    const SECTION_HEIGHT = 60 // Usar la altura máxima que puede tener una sección

    // Dibujar la gráfica
    const chartX = sideMargin + 4
    if (!noData) {
      doc.addImage(
        imgData,
        "PNG",
        chartX,
        contentTopY - 5,
        finalWidth,
        finalHeight
      )
    }

    const colX = sideMargin + columnWidth * 3.2

    const drawMetric = (color, label, value, suffix = "") => {
      const squareSize = 3
      const squareX = colX
      const textX = colX + 6

      doc.setFont("Cairo-SemiBold", "normal")
      doc.setFontSize(12)
      doc.setTextColor(valueColor)

      const valueText = String(value)
      doc.text(valueText, textX, colY)

      if (suffix) {
        doc.setFontSize(9)
        const valueWidth = doc.getTextWidth(valueText)
        doc.text(suffix.toLowerCase(), textX + valueWidth + 3, colY)
      }

      const labelY = colY + 3
      doc.setFont("Mulish-Bold", "normal")
      doc.setFontSize(7.5)
      doc.setTextColor(labelColor)
      doc.text(label, textX, labelY)

      const boxY = colY - 1
      if (color === "#F3F6F7") {
        doc.setFillColor("#F3F6F7")
        doc.setDrawColor("#C3D1D9")
        doc.setLineWidth(0.4)
        doc.roundedRect(squareX, boxY, squareSize, squareSize, 0.8, 0.8, "FD")
      } else {
        doc.setFillColor(color)
        doc.roundedRect(squareX, boxY, squareSize, squareSize, 0.8, 0.8, "F")
      }

      colY += rowHeight
    }

    const rawDeveloped = burnchartSummary?.toDevelop
    const formattedDeveloped =
      rawDeveloped == null || rawDeveloped === "-" ?
        "-"
      : `~${numberFormatter(rawDeveloped)}`

    const metrics = [
      {
        color: "#F3F6F7",
        label: "Alcance actual",
        value: formattedDeveloped,
        suffix: "pts dev",
      },
      {
        color: "#059BB4",
        label: "Avance actual",
        value: numberFormatter(burnchartSummary?.developed),
        suffix: "pts dev",
      },
    ]

    if (hasMilestoneTotalPoints) {
      metrics.splice(1, 0, {
        color: "#8A38F5",
        label: "Alcance fase actual",
        value: numberFormatter(milestoneTotalPoints),
        suffix: "pts dev",
      })
    }

    if (hasReleaseInfo) {
      metrics.push({
        color: "#006AA6",
        label: releaseName,
        value: releaseDate,
        suffix: "",
      })
    }

    const metricsReferenceHeight = 55
    /* const metricsTop =
      contentTopY - 5 + (finalHeight - metricsReferenceHeight) / 2 */
    const rowHeight = 12
    const blockHeight = metrics.length * rowHeight
    const metricsTop = contentTopY - 5 + (SECTION_HEIGHT - blockHeight) / 2
    let colY = metricsTop
    // 3) Pintar métricas
    metrics.forEach((item) => {
      drawMetric(item.color, item.label, item.value, item.suffix)
    })

    const chartBottom =
      noData ? contentTopY + SECTION_HEIGHT : contentTopY + finalHeight

    const sectionBottom = Math.max(chartBottom, colY) - 3

    doc.setDrawColor(204, 212, 222)
    doc.setLineWidth(0.3)
    doc.line(sideMargin, sectionBottom, pageWidth - sideMargin, sectionBottom)

    return sectionBottom + 10
  } catch (error) {
    console.error("Error burnchart:", error)
    return y + 10
  }
}
